<div class="refresh-warning p-6">
    <p [innerHTML]="'refresh-page-warning.text-1' | translate"></p>
    <p class="mt-3" [innerHTML]="'refresh-page-warning.text-2' | translate"></p>
</div>
